import { Button, cn, Col, Row } from '@rematter/ui-web';
import { LucideCircleAlert, LucideX } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

interface ErrorMessageDisplayProps {
  error: string;
  errorCode?: string;
  onDismiss?: () => void;
}

//
// ⚛️ ⚛️ ⚛️ ERROR MESSAGE DISPLAY ⚛️ ⚛️ ⚛️
//
export const ErrorMessageDisplay = ({
  error,
  errorCode,
  onDismiss,
}: ErrorMessageDisplayProps) => {
  const t = useTranslations();

  return (
    <Row
      yStart
      gap3
      className={cn(
        '@ErrorMessageDisplay',
        'rounded-lg border border-failure/20 bg-failure/10 p-4',
      )}
    >
      <div className="flex-shrink-0 pt-0.5 text-failure">
        <LucideCircleAlert size={20} />
      </div>

      <Col gap1 className="flex-1">
        <div className="font-medium text-failure">{t.chat.errorLabel}</div>
        <div className="text-sm text-neutral/80">{error}</div>
        {errorCode && (
          <div className="text-xs text-neutral/60">
            {t.chat.errorCode} {errorCode}
          </div>
        )}
      </Col>

      {onDismiss && (
        <Button
          onClick={onDismiss}
          variant="text"
          color="neutral"
          size="small"
          className="flex-shrink-0 p-1 text-neutral/60 hover:text-neutral"
        >
          <LucideX size={20} />
        </Button>
      )}
    </Row>
  );
};
